import { Box, Typography } from "@mui/material";
import { isNil } from "lodash";
import { Navigate } from "react-router-dom";

import { useAuthContext } from "../../../../hooks";
import { CreateCompanyProfile } from "../CreateCompanyProfile";

interface Props {
  handleSearchCompanySelected: () => void;
}

const NO_ROLES_MESSAGE = (
  <Typography textAlign="center" variant="h4" fontWeight="bold">
    We can not help you create a company because you do not have any roles.
    Please contact us for assistance.
  </Typography>
);

export function CreateCompany(props: Props) {
  const { user } = useAuthContext();
  const { handleSearchCompanySelected } = props;

  if (!user || user.roles.length === 0) {
    return <Box>{NO_ROLES_MESSAGE}</Box>;
  }

  if (!isNil(user.roles[0].company)) {
    return <Navigate to="/" replace />;
  }

  const { type } = user.roles[0];
  if (type !== "CARRIER" && type !== "SHIPPER") {
    return <Box>{NO_ROLES_MESSAGE}</Box>;
  }

  return (
    <Box>
      <CreateCompanyProfile
        handleSearchCompanySelected={handleSearchCompanySelected}
        companyType={type}
      />
    </Box>
  );
}
